export default "__VITE_ASSET__pyQxOyJX__"